// Types
import { SessionExpireHookType } from '../hooks/types/session-expire.hook.type';

const sessionExpireSnackbarShouldBeOpened = (
  sessionWarningMessage: SessionExpireHookType['sessionWarningMessage']
): boolean => sessionWarningMessage !== '';

export { sessionExpireSnackbarShouldBeOpened };
